module.exports = __webpack_public_path__ + "media/icons/bolt-light-ec6e6134.svg";